<template>
  <div class="contain p-shadow-1">
    <div class="p-d-flex">
      <p class="label">start</p>
      <p class="label">end</p>
    </div>
    <div class="selectors">
      <TimeSelector ref="startTS" class="selector" @play="play" />
      <TimeSelector ref="endTS" class="selector" type="end" @play="play" />
    </div>
    <div class="inputs">
      <div class="p-fluid title">
        <label>title</label>
        <SetTitle ref="setTitle" />
      </div>
      <div class="p-fluid tags">
        <label>tags</label>
        <SetTags ref="setTags" />
      </div>
    </div>
    <div class="addButton">
      <Button @click="exportParams" label="追加" class="" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import TimeSelector from "@/components/TimeSelector.vue";
import Button from "primevue/button";
import SetTitle from "@/components/SetTitle.vue";
import SetTags from "@/components/SetTags.vue";

export default defineComponent({
  name: "SongEditorPart",
  components: { TimeSelector, Button, SetTitle, SetTags },
  methods: {
    play(start) {
      console.log("songeditorpart", "play");
      this.$emit("play", start);
    },
    exportParams() {
      this.$emit("exportParam", {
        start: this.$refs.startTS.time,
        end: this.$refs.endTS.time,
        title: this.$refs.setTitle.title,
        tags: this.$refs.setTags.queries,
      });
    },
    setTagsFilter() {
      console.log("songeditorpart setFilter");
      this.$refs.setTags.setFilter();
    },
  },
});
</script>

<style scoped>
.label {
  width: 50%;
  text-align: left;
}
.inputs {
  text-align: left;
}
.contain {
  padding: 16px;
  background-color: whitesmoke;
}
.addButton {
  margin-top: 10px;
  text-align: right;
}
.title {
  width: calc(100% - 52px);
}
.tags {
  width: calc(100% - 20px);
}
.selector {
  margin: auto;
}
.selectors {
  display: flex;
}
</style>
